import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { useSegment } from '@sparknz/journeys-common';

import { useProductDetails } from 'journey/productDetails/provider';
import { IfpEligibilityCheckSteps } from 'journey/productDetails/typings';
import { trackLinkedProductsEvent } from 'journey/productDetails/utils';
import { trackAccountSelection } from 'shared/components/AccountSelectorModal/useTrackAccountSelection/trackAccountSelection';
import { extractFirstValue } from 'shared/utils';

export default function useTrackIfpAccountSelector(numberOfAccount: number) {
  const { selectedDevice, ifpEligibility, paymentOptions } =
    useProductDetails();
  const { isBusiness } = useSegment();
  const router = useRouter();
  const ifpId = extractFirstValue(router.query.ifpId);
  const showIfpAccountSelector =
    ifpEligibility.activeStep === IfpEligibilityCheckSteps.AccountSelection;

  useEffect(() => {
    if (showIfpAccountSelector) {
      trackLinkedProductsEvent({
        eventInfo: {
          eventName: 'Mobile Plan Selector Account View',
          eventAction: 'shop.mobilePlanSelector.account.view',
        },
        device: selectedDevice,
        isBusiness,
        paymentOption: paymentOptions?.find(({ id }) => id === ifpId),
      });
    }
  }, [
    selectedDevice,
    isBusiness,
    showIfpAccountSelector,
    paymentOptions,
    ifpId,
  ]);

  useEffect(() => {
    trackAccountSelection({ numberOfAccount });
  }, [numberOfAccount]);
}
